import React from 'react';
import Header from "../../Layouts/Header";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import API from "../../Services/API";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";

const EditProfile = () => {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [user, setUser] = React.useState([]);
    const [email, setEmail] = React.useState('');
    const [name, setName] = React.useState('');
    const [surname, setSurname] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [passwordRe, setPasswordRe] = React.useState('');
    React.useEffect(() => {

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if(!token) {
            navigate('/login');
        }
        API.getUser()
            .then((response) => {
                setUser(response.user);
                setEmail(response.user.email)
                setName(response.user.name)
                setSurname(response.user.surname)
                setIsLoaded(true)

            })
            .catch((error) => {

                if (error.response) {
                    toast.error(error.response.data.message);
                    setTimeout(() => {
                        window.history.back()
                    }, 1200)
                } else {
                    toast.error(error.message);
                    setTimeout(() => {
                        window.history.back()
                    }, 1200)
                }
            });


    }, []);


    const OnUpdateInfo = () => {

        if (password.length > 0 && password.length < 8) {
            toast.error('Password Should Be At Least 8 Character')
            return false
        }
        if (password.surname < 3) {
            toast.error('Surname Is Mandatory')
            return false
        }

        if (password !== passwordRe) {
            toast.error("Password And It's Confirmation Are Not Same")
            return false
        }

        const request = {
            name,
            surname,
            password,
            email
        }
        API.updateUser(request)
            .then((response) => {
                toast.success(response.message);
                setIsLoaded(true)
                if (password.length > 0) {
                    localStorage.clear();
                    document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                    window.location.replace("/")
                }
            })
            .catch((error) => {
                setIsLoaded(true)
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }

    return (
        <React.Fragment>
            <Header/>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }

            <section className="container mt-5 p-md-5">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title my-4">Edit Profile</h5>
                                
                              <div className="row">
                                  <div className="col-md-6">
                                      <div className="form-floating mb-3">
                                          <input type="email" className="form-control" id="floatingInput"
                                                 value={user?.username}
                                                 disabled={true}
                                                 placeholder="info"/>
                                          <label htmlFor="floatingInput">User Name</label>
                                      </div>
                                  </div>
                                  <div className="col-md-6">
                                      <div className="form-floating mb-3">
                                          <input type="email" className="form-control" id="floatingInput"
                                                 value={email}
                                                 onChange={(val) => {
                                                     setEmail(val.target.value)
                                                 }}
                                                 placeholder="info"/>
                                          <label htmlFor="floatingInput">Email Address</label>
                                      </div>
                                  </div>
                                  <div className="col-md-6">
                                      <div className="form-floating mb-3">
                                          <input type="text" className="form-control" id="floatingInput"
                                                 value={name}
                                                 onChange={(val) => {
                                                     setName(val.target.value)
                                                 }}
                                                 placeholder="info"/>
                                          <label htmlFor="floatingInput">Name</label>
                                      </div>
                                  </div>
                                  <div className="col-md-6">
                                      <div className="form-floating mb-3">
                                          <input type="text" className="form-control" id="floatingInput"
                                                 value={surname}
                                                 onChange={(val) => {
                                                     setSurname(val.target.value)
                                                 }}
                                                 placeholder="info"/>
                                          <label htmlFor="floatingInput">Surname</label>
                                      </div>
                                  </div>
                                  <div className="col-md-6">
                                      <div className="form-floating mb-3">
                                          <input type="password" className="form-control" id="floatingInput"
                                                 value={password}
                                                 onChange={(val) => {
                                                     setPassword(val.target.value)
                                                 }}
                                                 placeholder="info"/>
                                          <label htmlFor="floatingInput">Password</label>
                                      </div>
                                  </div>
                                  <div className="col-md-6">
                                      <div className="form-floating mb-3">
                                          <input type="password" className="form-control" id="floatingInput"
                                                 value={passwordRe}
                                                 onChange={(val) => {
                                                     setPasswordRe(val.target.value)
                                                 }}
                                                 placeholder="info"/>
                                          <label htmlFor="floatingInput">Password Confirmation</label>
                                      </div>
                                  </div>

                                  <div className="col-12 mt-5">
                                      <div className="text-center pt-1 mb-5 pb-1">
                                          <button
                                              className="btn btn-primary btn-block fa-lg gradient-custom-2 mb-3"
                                              type="button"
                                              onClick={OnUpdateInfo}

                                          >
                                              Update Information
                                          </button>

                                      </div>
                                  </div>
                              </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </React.Fragment>
    );
};

export default EditProfile;